import { registerNavigateAwayGuard } from "@/router/onNavigateAway.guard";
import store from "@/store";
import { LOVE_FIRST_SEGMENT } from "@/apps/love/love.routes";

registerNavigateAwayGuard({
    segment: LOVE_FIRST_SEGMENT,
    async onDropChanges() {
        await store.dispatch("love/projects/loadProject", store.state.love.wall.uuid);
    },
    async onSaveChanges() {
        await store.dispatch("love/projects/saveSnapshot");
    },
});
